import React from "react"
import { Skeleton } from "@walmart-web/livingdesign-components"

const CustomerDescriptionSkeleton = () => {
	return <Skeleton height="1.5rem" />
}

export default CustomerDescriptionSkeleton
